/**
 * Service used by neo to perform decimal operations.
 * This class can be used by any of the decimal packages in the repos under https://github.com/MikeMcl.
 * `big.js` is the smallest package, `decimal.js-light` is slightly larger, but newer with a slightly easier api.
 */
var DecimalService = /** @class */ (function () {
    function DecimalService(decimalType, roundHalfUpValue, roundDownValue) {
        this.decimalType = decimalType;
        this.roundHalfUpValue = roundHalfUpValue;
        this.roundDownValue = roundDownValue;
        var prototype = decimalType.prototype;
        if (prototype.round) {
            this.roundFn = prototype.round;
        }
        else if (prototype.toDecimalPlaces) {
            this.roundFn = prototype.toDecimalPlaces;
        }
        else {
            throw "Decimal type doesn't provide rounding function";
        }
    }
    DecimalService.prototype.isDecimal = function (value) {
        return value instanceof this.decimalType;
    };
    DecimalService.prototype.createDecimal = function (value) {
        return new this.decimalType(value);
    };
    DecimalService.prototype.toNumber = function (value) {
        if (this.isDecimal(value)) {
            return value.toNumber();
        }
        else {
            return value;
        }
    };
    DecimalService.prototype.round = function (value, precision) {
        return this.roundFn.call(value, precision, this.roundHalfUpValue);
    };
    DecimalService.prototype.truncate = function (value) {
        return this.roundFn.call(value, 0, this.roundDownValue);
    };
    DecimalService.prototype.compare = function (value1, value2) {
        return value1.cmp(value2);
    };
    DecimalService.prototype.sum = function (values) {
        return values.reduce(function (total, item) { return total.plus(item); }, this.createDecimal(0));
    };
    DecimalService.prototype.divideBy = function (value, divisor) {
        return value.div(divisor);
    };
    return DecimalService;
}());
export { DecimalService };
